import { apiSlice } from "./apiSlice";
import {
  ADD_REVIEW_URL,
  UPDATE_REVIEW_URL,
  GET_REVIEWS_URL,
  HAS_PURCHASED_REVIEW_URL,
} from "../constants";

export const reviewSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addReview: builder.mutation({
      query: ({ productId, reviewData }) => ({
        url: ADD_REVIEW_URL(productId),
        method: "POST",
        body: reviewData,
      }),
    }),
    updateReview: builder.mutation({
      query: ({ productId, reviewData }) => ({
        url: UPDATE_REVIEW_URL(productId),
        method: "PUT",
        body: reviewData,
      }),
    }),
    getReviews: builder.query({
      query: (productId) => ({
        url: GET_REVIEWS_URL(productId),
        method: "GET",
      }),
    }),
    checkHasPurchased: builder.query({
      query: (productId) => ({
        url: HAS_PURCHASED_REVIEW_URL(productId),
        method: "GET",
      }),
    }),
  }),
});

export const {
  useAddReviewMutation,
  useUpdateReviewMutation,
  useGetReviewsQuery,
  useCheckHasPurchasedQuery,
} = reviewSlice;
